<div class="loading-state" *ngIf="loading">
  <div class="loading"></div>
</div>
<div class="container-fluid g-0 py-3Point4">
  <img 
    src="./assets/params/images/home/banner_desktop.jpg" 
    alt="Banner"
    width="100%"
    height="50%"
  />
</div>
<form [formGroup]="userForm" class="needs-validation" autocomplete="off" novalidate (ngSubmit)="onSubmit()">
  <div class="custom-container py-1">
    <div class="row">
      <div class="col-2 g-lg-0"></div>
      <div class="col-md-8 col-sm-8 col-lg-8 text-black fs-5 fw-bold pt-5">
        Detail Perangkat
      </div>
      <div class="col-2 g-lg-0"></div>
    </div>
    
    <div class="row pt-3">
      <div class="col-2 g-lg-0"></div>
      <div class="col-md-8 col-8 mb-4 mb-md-0">
        <label for="imei" class="form-label">IMEI</label>
        <input 
          type="text" 
          class="form-control" 
          id="imei"
          maxlength="15"
          minlength="15"
          digitOnly
          placeholder="e.g.123451234512345"
          [formControl]="imei"
        />
        <div *ngIf="imei.invalid && (imei.dirty || imei.touched || submitted)" class="invalid-feedback">
          <div *ngIf="imei.hasError('required')">IMEI diperlukan.</div>
          <div *ngIf="imei.hasError('minlength')">Minimal 15 digit diperlukan untuk IMEI.</div>
        </div>
      </div>
      
      <div class="col-2 g-lg-0"></div>
    </div>
  
    <div class="row pt-3">
      <div class="col-2 g-lg-0"></div>
      <div class="col-md-8 col-8 mb-4 mb-md-0">
        <p>*IMEI adalah 15 digit kode unik untuk perangkat Anda yang menggunakan kartu SIM. 
          Kami menggunakan IMEI untuk menerbitkan sertifikat asuransi dan mengidentifikasi 
          perangkat Anda saat proses klaim</p>
      </div>
      <div class="col-2 g-lg-0"></div>
    </div>
  
    <div class="row pt-3">
      <div class="col-2 g-lg-0"></div>
      <!-- Center the content and make it responsive -->
      <div class="col-md-8 col-8 mb-4 mb-md-0">
        <div class="row align-items-center" 
              data-bs-toggle="collapse" 
              data-bs-target="#bagaimana" 
              aria-expanded="false" 
              aria-controls="bagaimana" 
              style="cursor: pointer;">
          <!-- Question Section -->
          <div class="col-11">
            <p>Bagaimana cara menemukan nomor IMEI saya?</p>
          </div>
          <!-- Expand/Collapse Icon -->
          <div class="col-1 text-end align-self-start">
            <!--mat-icon>arrow_drop_down</mat-icon-->
            <span class="toggle-icon">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="12" height="7" viewBox="0 0 12 7">
                <image xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAHCAYAAAA8sqwkAAAAAXNSR0IArs4c6QAAAHxJREFUKFNjZNh9sp7h3z8GBnfLRgZcYOfJeAbGfw4MbpaJjAw7jzcwMDLUM/xnaMCqCaJ4AQMD4wWGr+yOjGBDcWlCU8wQaPgBogGbJiyKQcoQGlA0/d/AwMgYAHMGyGSYuagakDVB3YysGNMGmDE7jhUwfOdcgK4YJA0A424/ltS0kscAAAAASUVORK5CYII=" x="0" y="0" width="12" height="7" />
              </svg>
            </span>
          </div>
        </div>
      </div>
      <div class="col-2 g-lg-0"></div>
    </div>
    
    <!-- Collapsible Content -->
    <div class="row collapse" id="bagaimana">
      <div class="row" >
        <div class="col-2 g-lg-0"></div>
        <div class="col-md-8 col-8 mb-4 mb-md-0" >
          <div class="row col-md-12 col-12 mb-12 mb-md-0">
            <p class="mb-0 fw-bold">Opsi 1 – Ketik #06#</p>
          </div>
        </div>
        <div class="col-2 g-lg-0"></div>
      </div>

      <div class="row mt-2">
        <div class="col-2 g-lg-0"></div>
        <div class="col-md-8 col-8 mb-4 mb-md-0">
          <div class="row">
            <div class="col-md-1 col-sm-1 col-2">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26" height="23" viewBox="0 0 26 23">
                <image xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXCAYAAAAV1F8QAAAAAXNSR0IArs4c6QAAAb1JREFUSEu1lo0xBEEQhd9lQAZEgAgQASJABIgAESACROBE4DJwGSACMmC+rXljb39mRp3rqqvdre3r1/36TfdOVLY1SWeS9iRtS+IZm0t6l/Qc3s3i/Wi0SQZnI7y7knQg6TGATGMwgmOA4nMoaTfcP0i6Hos3BkT2T5LuQgW3kr4KhTspAPeHqhsCOo6VnEZKyuT+esAA/++BdYHI7DXwvlPiPINuMGIkJrpAb5Fn+F7GoPtb0oWDtIFOQhX86E/OUB1+JDPWO3xIetM+bSAoIwOkOmSo7KYlcYJYgUP+UIg1VwPRm5eYwVg10AEYlFB1CQife8c0EGcBOriWDMpQVgmIOJ+mz0ALZRaQ/gJEOzgm81UD0Q6mxawNhFLOS7xFtdVSlwRmIPdn5T3yRFj/x4pQKKpjQiR5c5/4rACrcfGBbtrRnQweiDWBcj4+l2m4dmcdzeNgsn+WsYVquhXxDK/socGdUol8GQ9/dnoTCwXifBTXdWX8xs0gxX3koMicAQoFbNmaDYvCOIsk2Bu2Nd8MrGcmOn3jg8SgNJzBiYCgnIQ8ynos5IDs7A8QqtxqfQV9RGCSyO2mJs4PmXprGLycqAoAAAAASUVORK5CYII=" x="0" y="0" width="26" height="23"/>
              </svg>
            </div>
            <div class="col-md-10 col-10">
              <p class="mb-0">
                Buka aplikasi telepon di perangkat Anda.
              </p>
            </div>
          </div>
        </div>
        <div class="col-2 g-lg-0"></div>
      </div>

      <div class="row mt-2">
        <div class="col-2 g-lg-0"></div>
        <div class="col-md-8 col-8 mb-4 mb-md-0">
          <div class="row">
            <div class="col-md-1 col-sm-1 col-2">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26" height="23" viewBox="0 0 26 23">
                <image xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXCAYAAAAV1F8QAAAAAXNSR0IArs4c6QAAAe5JREFUSEulloExBEEQRf9lQASIABEgAkSACBABIkAEiOCIwInAZYAIEAHztqbX7Nz2zKCrrm6vdqZ/9/9/em6ieixJOpa0LWlDEr+JuaRXSQ/h3Sw+u9kmBZzV8O5c0q6kuwByH5ORnACUNXuStsLzraQLL58HRPVTSdehgytJH5XGrSgAd8a6GwM6iJ0cRUrq5P6sgAH2L4DlQFT2HHjfrHFeQDcwcvRM5EAvkWf4/k9A95ekU0uSAh2GLvigjxe8R4fPKD7OGwucSdFr1lUKBGVUgFXH4jJsOgn8P0laiY5DC289FBLdtwGhzWOswKvwPXaBSbA2hWFnS5jvg5kby2lAnAVo4dsLikFcPiShMEBLelJcR58BDdqsuAD+6YYYPTPJftZRzPy3QIDQCd21HAHWQu8sBSIJYpcCzqEYEM9x6f7eYAZk+pQ0MhBcxuwj0IsZ6MWCRjYRlgubOIB5MGAReyxwJsXRfW9vnns+K/S1vsaNdNzJkU8GG4itybx1di57V+azDvGYU6bBXwEH3eQd8RteuYdq56NUwFniTHd6kwAHsni/0cIpqIFU7yPbhM0ZolDALdtyw+IwziIF2nXfF9Hyn4Frwc4Oh9RAEZyZh4GgnIK8ATtwXclBdMhnPfkX9BappQgT39XuG4wAchgPdmYbAAAAAElFTkSuQmCC" x="0" y="0" width="26" height="23"/>
              </svg>
            </div>
            <div class="col-md-10 col-10">
              <p class="mb-0">
                Ketik *#06# pada papan tombol (keypad).
              </p>
            </div>
          </div>
        </div>
        <div class="col-2 g-lg-0"></div>
      </div>

      <div class="row mt-2">
        <div class="col-2 g-lg-0"></div>
        <div class="col-md-8 col-8 mb-4 mb-md-0">
          <div class="row">
            <div class="col-md-1 col-sm-1 col-2">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26" height="23" viewBox="0 0 26 23">
                <image xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXCAYAAAAV1F8QAAAAAXNSR0IArs4c6QAAAf1JREFUSEulloExBEEQRf9lQASIABEgAkSACBABIkAEiOCIwInAZYAIEAHzruavvb3tmVXXVVe7e9vTv/v3n54dqW4rkk4l7UraksQzNpX0LukpvZvk+zDaqICznt5dStqX9JBAHnMwgmOA4nMgaSfd30u6iuJFQGQ/lnSbKriR9FUp3EkBuNdXXR/QUa7kJFNSJ/fPAwZYvwDWBSKz18T7do3zArrBiNEw0QV6yzzD9zIG3T+Szh2kDXScquBHf/oMtfF+MwX4zs1HeZEvSW+4qjYQlJEBUu0zxIHCXiStZcXRi8gfCrHZ1UD05jlnEFEGnVQALUibxFDlWbAAZu4c00BkCi1chxjBryWhzFI/P02fgebKLCCRJZVjUAZ1JaNqkpn+FwhBQBuVM5boKVRGRlJMi0kbiCAR3/SQauiRlYZ8mXMluhuBGcj9iRaRBHwDQhXMP5KiP1AT2UKPPBFWC4tIAgHgiyFz/ovmIBSjOiZEI2/uGz4rDQaI4LVBS7X4zNrRnQweiEMkXvLxvmyGa3fW0TxUxPmzjM1V062IZ3hl1PSeKQORL/LmL05vYqFAnA9bUh6IMVvH+up55IBWGBQwz2qNpycojG1Agj7umwSHfDNwPDNu6Bv7yKDexAgIyknIo2yBgRKQnf0BQpWcRf4K+sjAJOHmhxT/AqL5dRhfrwOWAAAAAElFTkSuQmCC" x="0" y="0" width="26" height="23"/>
              </svg>
            </div>
            <div class="col-md-10 col-10">
              <p class="mb-0">
                Informasi mengenai nomor IMEI perangkat Anda akan otomatis muncul di layar.
              </p>
            </div>
          </div>
        </div>
        <div class="col-2 g-lg-0"></div>
      </div>
      
      <div class="row mt-2">
        <div class="col-2 g-lg-0"></div>
        <div class="col-md-8 col-8 mb-4 mb-md-0">
          <div class="row">
            <div class="col-md-1 col-sm-1 col-2">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26" height="23" viewBox="0 0 26 23">
                <image xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXCAYAAAAV1F8QAAAAAXNSR0IArs4c6QAAAc5JREFUSEvFlo1NAzEMRr9uABvABJQNYAJgAugEsAFlgzIBZQJgAsoEsAFlAjoCeSf7lF4vvrRCYKkCKYmffz4nN9Kw7Um6knQm6cB+nFpJ+pD0KGmR9iwjV6NgEcCtQdwZjt0h0HGCnVsQz5LuSsASCAdPkl5SIFOLPgoY6I0BLyzTtf19ICJ8kMQBSrKNnViAk5QtGbbWBRHZq0Eo0y7m1TjNy9gFfUq6lzTbhZCd8TICaywHoazr1JfjCgh7yZ6AUF+fURlENO+CWCCbtdr2eABA5thhIGv6hWqbrDwjDr8n0H5FNkDYPwRi/duCWTkIpVEO/kbmc4Ua2R9lhB+qw2/uIGaFAaWJJfOSIV3+BzoEoocM+CwHAQBYMnoIANBlVoG3QBDub+ogMvHp7gPlAuiuR1m5KluQ9yfqkQsAEIExCigquj2a/tAnz4j+oKYa1XmJa3qE6pjLZT6w9IDbd9v7rdRTqkPmzNPGzUCT22ujYqaiLcwlF8DGzcAhsuJp+I27jh4ilMb+7fYG/ifvkWfqbwrypM7h94DdKqiQIKtfWIcxN0w2HyUA6V3fNwOqQkQ8CcVnP/o4yYE4Y6iPLHrWvixTH8rSu9T4+QEm0m4YLDAi7AAAAABJRU5ErkJggg==" x="0" y="0" width="26" height="23"/>
              </svg>
            </div>
            <div class="col-md-10 col-10">
              <p class="mb-0">
                Masukkan nomor IMEI tersebut ke dalam kolom yang tersedia.
              </p>
            </div>
          </div>
        </div>
        <div class="col-2 g-lg-0"></div>
      </div>

      <div class="row mt-2">
        <div class="col-2 g-lg-0"></div>
        <div class="col-md-8 col-8 mb-4 mb-md-0">
          <div class="row">
            <div class="col-md-12 col-12">
              <hr/>
            </div>
          </div>
        </div>
        <div class="col-2 g-lg-0"></div>
      </div>

      <div class="row" >
        <div class="col-2 g-lg-0"></div>
        <div class="col-md-8 col-8 mb-4 mb-md-0" >
          <div class="row col-md-12 col-12 mb-12 mb-md-0">
            <p class="mb-0 fw-bold">Opsi 2 – Temukan melalui pengaturan perangkat</p>
          </div>
        </div>
        <div class="col-2 g-lg-0"></div>
      </div>

      <div class="row mt-2">
        <div class="col-2 g-lg-0"></div>
        <div class="col-md-8 col-8 mb-4 mb-md-0">
          <div class="row">
            <div class="col-md-1 col-sm-1 col-2">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26" height="23" viewBox="0 0 26 23">
                <image xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXCAYAAAAV1F8QAAAAAXNSR0IArs4c6QAAAb1JREFUSEu1lo0xBEEQhd9lQAZEgAgQASJABIgAESACROBE4DJwGSACMmC+rXljb39mRp3rqqvdre3r1/36TfdOVLY1SWeS9iRtS+IZm0t6l/Qc3s3i/Wi0SQZnI7y7knQg6TGATGMwgmOA4nMoaTfcP0i6Hos3BkT2T5LuQgW3kr4KhTspAPeHqhsCOo6VnEZKyuT+esAA/++BdYHI7DXwvlPiPINuMGIkJrpAb5Fn+F7GoPtb0oWDtIFOQhX86E/OUB1+JDPWO3xIetM+bSAoIwOkOmSo7KYlcYJYgUP+UIg1VwPRm5eYwVg10AEYlFB1CQife8c0EGcBOriWDMpQVgmIOJ+mz0ALZRaQ/gJEOzgm81UD0Q6mxawNhFLOS7xFtdVSlwRmIPdn5T3yRFj/x4pQKKpjQiR5c5/4rACrcfGBbtrRnQweiDWBcj4+l2m4dmcdzeNgsn+WsYVquhXxDK/socGdUol8GQ9/dnoTCwXifBTXdWX8xs0gxX3koMicAQoFbNmaDYvCOIsk2Bu2Nd8MrGcmOn3jg8SgNJzBiYCgnIQ8ynos5IDs7A8QqtxqfQV9RGCSyO2mJs4PmXprGLycqAoAAAAASUVORK5CYII=" x="0" y="0" width="26" height="23"/>
              </svg>
            </div>
            <div class="col-md-10 col-10">
              <p class="mb-0">
                Buka menu Pengaturan (Settings) di ponsel Anda.
              </p>
            </div>
          </div>
        </div>
        <div class="col-2 g-lg-0"></div>
      </div>

      <div class="row mt-2">
        <div class="col-2 g-lg-0"></div>
        <div class="col-md-8 col-8 mb-4 mb-md-0">
          <div class="row">
            <div class="col-md-1 col-sm-1 col-2">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26" height="23" viewBox="0 0 26 23">
                <image xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXCAYAAAAV1F8QAAAAAXNSR0IArs4c6QAAAe5JREFUSEulloExBEEQRf9lQASIABEgAkSACBABIkAEiOCIwInAZYAIEAHztqbX7Nz2zKCrrm6vdqZ/9/9/em6ieixJOpa0LWlDEr+JuaRXSQ/h3Sw+u9kmBZzV8O5c0q6kuwByH5ORnACUNXuStsLzraQLL58HRPVTSdehgytJH5XGrSgAd8a6GwM6iJ0cRUrq5P6sgAH2L4DlQFT2HHjfrHFeQDcwcvRM5EAvkWf4/k9A95ekU0uSAh2GLvigjxe8R4fPKD7OGwucSdFr1lUKBGVUgFXH4jJsOgn8P0laiY5DC289FBLdtwGhzWOswKvwPXaBSbA2hWFnS5jvg5kby2lAnAVo4dsLikFcPiShMEBLelJcR58BDdqsuAD+6YYYPTPJftZRzPy3QIDQCd21HAHWQu8sBSIJYpcCzqEYEM9x6f7eYAZk+pQ0MhBcxuwj0IsZ6MWCRjYRlgubOIB5MGAReyxwJsXRfW9vnns+K/S1vsaNdNzJkU8GG4itybx1di57V+azDvGYU6bBXwEH3eQd8RteuYdq56NUwFniTHd6kwAHsni/0cIpqIFU7yPbhM0ZolDALdtyw+IwziIF2nXfF9Hyn4Frwc4Oh9RAEZyZh4GgnIK8ATtwXclBdMhnPfkX9BappQgT39XuG4wAchgPdmYbAAAAAElFTkSuQmCC" x="0" y="0" width="26" height="23"/>
              </svg>
            </div>
            <div class="col-md-10 col-10">
              <p class="mb-0">
                Ketuk "Tentang Ponsel" (About Phone).
              </p>
            </div>
          </div>
        </div>
        <div class="col-2 g-lg-0"></div>
      </div>

      <div class="row mt-2">
        <div class="col-2 g-lg-0"></div>
        <div class="col-md-8 col-8 mb-4 mb-md-0">
          <div class="row">
            <div class="col-md-1 col-sm-1 col-2">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26" height="23" viewBox="0 0 26 23">
                <image xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXCAYAAAAV1F8QAAAAAXNSR0IArs4c6QAAAf1JREFUSEulloExBEEQRf9lQASIABEgAkSACBABIkAEiOCIwInAZYAIEAHzruavvb3tmVXXVVe7e9vTv/v3n54dqW4rkk4l7UraksQzNpX0LukpvZvk+zDaqICznt5dStqX9JBAHnMwgmOA4nMgaSfd30u6iuJFQGQ/lnSbKriR9FUp3EkBuNdXXR/QUa7kJFNSJ/fPAwZYvwDWBSKz18T7do3zArrBiNEw0QV6yzzD9zIG3T+Szh2kDXScquBHf/oMtfF+MwX4zs1HeZEvSW+4qjYQlJEBUu0zxIHCXiStZcXRi8gfCrHZ1UD05jlnEFEGnVQALUibxFDlWbAAZu4c00BkCi1chxjBryWhzFI/P02fgebKLCCRJZVjUAZ1JaNqkpn+FwhBQBuVM5boKVRGRlJMi0kbiCAR3/SQauiRlYZ8mXMluhuBGcj9iRaRBHwDQhXMP5KiP1AT2UKPPBFWC4tIAgHgiyFz/ovmIBSjOiZEI2/uGz4rDQaI4LVBS7X4zNrRnQweiEMkXvLxvmyGa3fW0TxUxPmzjM1V062IZ3hl1PSeKQORL/LmL05vYqFAnA9bUh6IMVvH+up55IBWGBQwz2qNpycojG1Agj7umwSHfDNwPDNu6Bv7yKDexAgIyknIo2yBgRKQnf0BQpWcRf4K+sjAJOHmhxT/AqL5dRhfrwOWAAAAAElFTkSuQmCC" x="0" y="0" width="26" height="23"/>
              </svg>
            </div>
            <div class="col-md-10 col-10">
              <p class="mb-0">
                Gulir ke bawah hingga Anda menemukan nomor yang tertera di bagian "IMEI (slot 1)".
              </p>
              <div class="row mt-3">
                <div class="col-md-10 col-10 bg-light-gray">
                  <div class="row mt-3">
                    <div class="col-md-6 col-6">
                      Phone Number
                    </div>
                    <div class="col-md-6 col-6 float-end text-end blur">
                      1234567890
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-6">
                      Model Number
                    </div>
                    <div class="col-md-6 col-6 float-end text-end blur">
                      1234567890
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-6">
                      Serial Number
                    </div>
                    <div class="col-md-6 col-6 float-end text-end blur">
                      1234567890
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-6">
                      IMEI (Slot 1)
                    </div>
                    <div class="col-md-6 col-6 float-end text-end blur">
                      123451234512345
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-6 col-6">
                      IMEI (Slot 2)
                    </div>
                    <div class="col-md-6 col-6 float-end text-end blur">
                      123451234512345
                    </div>
                  </div>
                </div>
                <div class="col-2 g-lg-0"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-2 g-lg-0"></div>
      </div>
      
      <div class="row mt-3">
        <div class="col-2 g-lg-0"></div>
        <div class="col-md-8 col-8 mb-4 mb-md-0">
          <div class="row">
            <div class="col-md-1 col-sm-1 col-2">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26" height="23" viewBox="0 0 26 23">
                <image xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXCAYAAAAV1F8QAAAAAXNSR0IArs4c6QAAAc5JREFUSEvFlo1NAzEMRr9uABvABJQNYAJgAugEsAFlgzIBZQJgAsoEsAFlAjoCeSf7lF4vvrRCYKkCKYmffz4nN9Kw7Um6knQm6cB+nFpJ+pD0KGmR9iwjV6NgEcCtQdwZjt0h0HGCnVsQz5LuSsASCAdPkl5SIFOLPgoY6I0BLyzTtf19ICJ8kMQBSrKNnViAk5QtGbbWBRHZq0Eo0y7m1TjNy9gFfUq6lzTbhZCd8TICaywHoazr1JfjCgh7yZ6AUF+fURlENO+CWCCbtdr2eABA5thhIGv6hWqbrDwjDr8n0H5FNkDYPwRi/duCWTkIpVEO/kbmc4Ua2R9lhB+qw2/uIGaFAaWJJfOSIV3+BzoEoocM+CwHAQBYMnoIANBlVoG3QBDub+ogMvHp7gPlAuiuR1m5KluQ9yfqkQsAEIExCigquj2a/tAnz4j+oKYa1XmJa3qE6pjLZT6w9IDbd9v7rdRTqkPmzNPGzUCT22ujYqaiLcwlF8DGzcAhsuJp+I27jh4ilMb+7fYG/ifvkWfqbwrypM7h94DdKqiQIKtfWIcxN0w2HyUA6V3fNwOqQkQ8CcVnP/o4yYE4Y6iPLHrWvixTH8rSu9T4+QEm0m4YLDAi7AAAAABJRU5ErkJggg==" x="0" y="0" width="26" height="23"/>
              </svg>
            </div>
            <div class="col-md-10 col-10">
              <p class="mb-0">
                Ketuk dan tahan untuk menyalin nomor IMEI.
              </p>
            </div>
          </div>
        </div>
        <div class="col-2 g-lg-0"></div>
      </div>

      <div class="row mt-2">
        <div class="col-2 g-lg-0"></div>
        <div class="col-md-8 col-8 mb-4 mb-md-0">
          <div class="row">
            <div class="col-md-1 col-sm-1 col-2">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26" height="23" viewBox="0 0 26 23">
                <image xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXCAYAAAAV1F8QAAAAAXNSR0IArs4c6QAAAeZJREFUSEvFloExREEMhv+rABWgAnRABagAFaACdHAqcCpABaiADpwK6ID9dpI3e+/eZs+NITNvzNjd/MmfP8mN1LZVSceS9iVt2MerT0mvkm4lPaU708jVKDgE4MJA3BmO3SGg2wnswIK4l3RVA6wB4eBO0kMK5NKijwIG9MwADy3TmftDQER4I4kHUPIT27UAT1K2ZNhZH4jIHg0EmpYxZ2OvpLEP9CbpWtJ4GYTijdMIWLYSCGWdprrsVEAQBw5KI+sZiopDmEFEkz4QB2RTewj/3HkvnHG3D+7H3Ee1OSvPiNq8JKC1gDJEghJ5uKhIPlJWm6jWgXACdfytGTInQnplPQE+Oy3BGzLmmzgQToZqUPpwIABWrFnPG8JBVDT4uATCKc4iIxhGD4aDL6MmYiH7dSAK6t1de+S0ulgQBj0T1ZWMCKwD8vpENUKmR5Kgi2wQBv9jCtQs14c6eUZQQrNG0ZExETLFMWpFgNHURnX05bRsWKhAUS3pEhRfuBZMwZSEfpqbDFDTjY2GMFrH9CUDYG4y8JCsWA2/MesYZzRrtn+b3oD/yT7yTH2nIE94bhXe1z5BLrxhHQw5MymQM4DUbug3A6pCRKyE6tqPfpyUgDijZ7ZM2pyxLsjUm9JH06AavwFm5nIYYYgP8AAAAABJRU5ErkJggg==" x="0" y="0" width="26" height="23"/>
              </svg>
            </div>
            <div class="col-md-10 col-10">
              <p class="mb-0">
                Tempelkan nomor IMEI ke kolom yang tersedia.
              </p>
            </div>
          </div>
        </div>
        <div class="col-2 g-lg-0"></div>
      </div>

    </div><!--collapse ends-->
    
    <div class="row">
      <div class="col-2 g-lg-0"></div>
      <div class="col-md-8 col-8 mb-4 mb-md-0">
        <hr/>
      </div>
      <div class="col-2 g-lg-0"></div>
    </div>
  
    <div class="row pt-3">
      <div class="col-2 g-lg-0"></div>
      <div class="col-md-8 col-sm-8 col-lg-8 text-black fw-bold fs-5">
        Rincian saya
      </div>
      <div class="col-2 g-lg-0"></div>
    </div>
  
    <div class="row pt-3">
      <div class="col-2 g-lg-0"></div>
      <div class="col-md-8 col-8 mb-4 mb-md-0">
        <label for="name" class="form-label">Nama Lengkap (sesuai KTP)</label>
        <input 
          type="text" 
          class="form-control" 
          id="name" 
          placeholder="contoh : John Doe"
          [formControl]="name"
          maxlength="35"
          pattern="[ a-zA-Z]*"
        />
        <div *ngIf="name.invalid && (name.dirty || name.touched || submitted)" class="invalid-feedback">
          <div *ngIf="name.hasError('required')">Nama Lengkap diperlukan.</div>
        </div>
        <div *ngIf="name.invalid && (name.dirty || name.touched || submitted)" class="invalid-feedback">
          <div *ngIf="name.hasError('pattern')">Mohon masukkan huruf</div>
        </div>
      </div>
      <div class="col-2 g-lg-0"></div>
    </div>
    
    <div class="row pt-3">
      <div class="col-2 g-lg-0"></div>
      <div class="col-md-8 col-8 mb-4 mb-md-0">
        <label for="mobile" class="form-label">Nomor HP</label>
        <div class="col-md-8 col-8 mb-4 mb-md-0 input-group">
          <select class="country-select">
            <option selected>+62</option>
          </select>
          <input 
            type="text" 
            class="form-control" 
            id="mobile" 
            placeholder="08xxxxxxxxx"
            [formControl]="mobile"
            maxlength="13"
            minlength="10"
            digitOnly
          />
        </div>
        
        
        <div *ngIf="mobile.invalid && (mobile.dirty || mobile.touched || submitted)" class="invalid-feedback">
          <div *ngIf="mobile.hasError('required')">Nomor HP diperlukan.</div>
          <div *ngIf="mobile.hasError('minlength')">Minimal 10 digit diperlukan untuk Nomor HP.</div>
        </div>
      </div>
      <div class="col-2 g-lg-0"></div>
    </div>
  
    <div class="row pt-3">
      <div class="col-2 g-lg-0"></div>
      <div class="col-md-8 col-8 mb-4 mb-md-0">
        <label for="email" class="form-label">Alamat Email</label>
        <input 
          type="text" 
          class="form-control" 
          id="email" 
          placeholder="email@example.com"
          [formControl]="email"
          maxlength="100"
        />
        <div *ngIf="email.invalid && (email.dirty || email.touched || submitted)" class="invalid-feedback">
          <div *ngIf="email.hasError('required')">Email diperlukan.</div>
          <div *ngIf="email.hasError('email')">Email tidak valid.</div>
        </div>
      </div>
      <div class="col-2 g-lg-0"></div>
    </div>
  
    <div class="row pt-3">
      <div class="col-2 g-lg-0"></div>
      <div class="col-md-8 col-8 mb-4 mb-md-0">
        <div class="form-check">
          <input 
            class="form-check-input"
            required
            type="checkbox"
            [formControl]="consent"
            id="consent" 
          />
          <label class="form-check-label" for="consent">
            Dengan ini saya menyatakan bahwa saya telah membaca, 
            memahami dan menyetujui <a href="./terms_and_condition.pdf" target="_blank"><b>Syarat dan Ketentuan Produk Asuransi</b></a>,
          </label>
        </div>
      </div>
      <div class="col-2 g-lg-0"></div>
    </div>
  
    <div class="row">
      <div class="col-2 g-lg-0"></div>
      <div class="col-md-8 col-8 mb-4 mb-md-0">
        <div class="form-check">
          dan menyatakan bahwa informasi yang saya berikan diatas adalah akurat dan benar.
          <div *ngIf="consent.invalid && (consent.dirty || consent.touched || submitted)" class="invalid-feedback">
            <div *ngIf="consent.hasError('required')">Mohon berikan persetujuan Anda.</div>
          </div>
        </div>
      </div>
      <div class="col-2 g-lg-0"></div>
    </div>
  
    <div class="row pt-3">
      <div class="col-2 g-lg-0"></div>
      <div class="col-md-8 col-8 mb-4 mb-md-0 d-flex justify-content-evenly">
        <button
          [ngClass]="{'btn-light-gray': userForm.invalid, 'btn-blue': userForm.valid}"
          class="btn plain-btn " 
          [disabled]="userForm.invalid || submitted"
          type="submit">Ajukan Sekarang
        </button>
      </div>
      <div class="col-2 g-lg-0"></div>
    </div>
  </div>
</form>


